<template>
    <div class="content">
        <div class="title">
            关于我们
            <div class="line"></div>
        </div>
        <h1>钧飞智能</h1>
        <h2>积蓄千钧，一朝飞跃</h2>
        <div>
            <p style="color: #e5d276;float: left; clear: right">JUNFEI TECH</p>
            （
            <b style="background-color: #FFFF66; color: #333333;">钧飞智能</b>
            ）
        </div>
        <p>于2016年成立于宁波国家高新区， 团队来自于国内外知名高校，致力于工业数据采集相关的设备研发、 工程实施、应用开发及系统维护的全生命周期的专业公司，团队拥有博士2名，本科及硕士研究生10余名。公司于2018 年获得国家高新技术企业称号，拥有发明专利、实用新型专利、软件著作权10余件，产品包括以太数据采集网关、4G数 采网关、5G数采网关、MQTT数据网关、工业交换机以及一键安装、远程批量配置、状态监控及数据可视化系列工业软件。 同时，公司业务延伸到智能化领域，产品包括智能家居产品、智慧教育产品、智能图书馆产品软、硬件，目前公司已与多 家上市公司及龙头企业建立战略合作关系， 共同致力于智能家居标准化和智能社区综合解决方案的长远发展。 目前研发 的智能家居等全系列的产品，现已应用在学校、政府大楼、医院、图书馆等地方。
        </p>
    </div>
</template>

<script>
  export default {
    name: "AboutUs",
    data() {
      return {}
    }
  }
</script>

<style scoped lang="less">
    .content {
        padding: 52px 130px 52px 170px;
        background-color: #eee;
        > h1 {
            width: 130px;
            margin-top: 50px;
            margin-bottom: 20px;
            font-size: 32px;
            color: #333333;
            background-color: #FFFF66;
        }

        > h2 {
            margin-top: -4px;
            margin-bottom: 40px;
            font-size: 30px;
            font-weight: normal;
        }
        >p {
            display: block;
            font-size: 24px;
            color: #595757;
            line-height: 40px;
        }

    }

    .title {
        text-align: center;
        font-size: 34px;
        color: #595757;
    }

    .line {
        width: 103px;
        background: #e5d276;
        height: 4px;
        margin: 10px auto;
    }



</style>
